import { render, staticRenderFns } from "./ChatbotResponseAnalysis.vue?vue&type=template&id=85ae58d4"
import script from "./ChatbotResponseAnalysis.vue?vue&type=script&lang=js"
export * from "./ChatbotResponseAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports